import { render, staticRenderFns } from "./clienrVisit.vue?vue&type=template&id=06b58ea2&scoped=true&"
import script from "./clienrVisit.vue?vue&type=script&lang=js&"
export * from "./clienrVisit.vue?vue&type=script&lang=js&"
import style0 from "./clienrVisit.vue?vue&type=style&index=0&id=06b58ea2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b58ea2",
  null
  
)

export default component.exports